import { CATALOGUE_ACTION_TYPES } from './actionTypes';

const initialState = {
    categoryIds: [],
    loading: false,
    error: null,
};

export const catalogueReducer = (state = initialState, action) => {
    switch (action.type) {
        case CATALOGUE_ACTION_TYPES.FETCH_REQUEST:
            return { ...state, loading: true, error: null };

        case CATALOGUE_ACTION_TYPES.FETCH_SUCCESS:
            return {
                ...state,
                categoryIds: action.payload.categoryIds,
                loading: false,
                error: null,
            };

        case CATALOGUE_ACTION_TYPES.FETCH_FAILURE:
            return { ...state, loading: false, error: action.payload.error };

        default:
            return state;
    }
};